import React from 'react';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';

const SeoSocial = () => {
  const { site, arcStory } = useStaticQuery(
    graphql`
        query SiteSocialQuery {
          site {
            siteMetadata {
              metaUrl
              siteName
              author
            }
          }
          arcStory(storyId: {eq: "KMGI2VS3XJEANBPNWN5KPS7JWU"}) {
            headlines {
              basic
            }
            promoImage {
              url
            }
            description {
              basic
            }
          }
        }
    `,
  );

  // Following four fields are requied. You can over ride them here.
  // Update URL in gatsby-congfig.js
  const metaUrl = site.siteMetadata.metaUrl ? site.siteMetadata.metaUrl : 'https://apps.bostonglobe.com/';
  const metaDescription = arcStory.description.basic ? arcStory.description.basic : 'A special project from The Boston Globe';
  const title = arcStory.headlines.basic ? arcStory.headlines.basic : 'The Boston Globe';
  const metaImage = arcStory.promoImage.url ? arcStory.promoImage.url : 'http://cache.boston.com/images/globe/email_images/CIRC_755_images/placeholder.png';
  return (
    <Helmet
      htmlAttributes={{
        lang: 'en-US',
      }}
      title={title}
      link={[
        {
          rel: 'canonical',
          href: metaUrl,
        },
      ]}
      titleTemplate="%s - The Boston Globe"
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:url',
          content: metaUrl,
        },
        {
          property: 'og:image',
          content: metaImage,
        },
        {
          property: 'og:site_name',
          content: 'BostonGlobe.com',
        },
        {
          property: 'og:type',
          content: 'article',
        },
        {
          property: 'og:city',
          content: 'Boston',
        },
        {
          property: 'og:state',
          content: 'MA',
        },
        {
          property: 'og:country',
          content: 'US',
        },
        {
          property: 'fb:admins',
          content: '100001044693856,507486035',
        },
        {
          property: 'fb:app_id',
          content: '103933749691726',
        },
        {
          property: 'fb:pages',
          content: '5637143257',
        },
        {
          property: 'article:publisher',
          content: 'https://www.facebook.com/globe',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:site',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:creator',
          content: '@BostonGlobe',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: metaDescription,
        },
        {
          name: 'twitter:image',
          content: metaImage,
        },
        {
          name: 'twitter:url',
          content: metaUrl,
        },
      ]}
    />
  );
};

export default SeoSocial;
